import { bankingApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSQueryCache, WSQueryConfig } from "@ws-react-query";
import { QUERY_INTERNAL_ACCOUNT } from "../../../query/banking/queries/useQueryInternalAccount";
import { useWSQuery } from "../../../query/helpers";
import { getInternalAccount } from "../../../services/api/banking/internalAccounts";
import {
  concurrentActions,
  WSServiceError
} from "../../../utils/serviceHelper";

export const QUERY_INTERNAL_ACCOUNT_BY_IDS = "QUERY_INTERNAL_ACCOUNT_BY_IDS";

export const useInternalAccountsForStatements = (
  internalAccountIds: string[],
  config?: WSQueryConfig<bankingApiSpec.InternalAccount[], WSServiceError>
) =>
  useWSQuery<bankingApiSpec.InternalAccount[], WSServiceError>(
    [QUERY_INTERNAL_ACCOUNT_BY_IDS, internalAccountIds],
    async () => {
      const actions = internalAccountIds.map(internalAccountId => async () => {
        const cachedInternalAccount =
          WSQueryCache.getQueryData<bankingApiSpec.InternalAccount>([
            QUERY_INTERNAL_ACCOUNT,
            internalAccountId
          ]);

        if (cachedInternalAccount) {
          return cachedInternalAccount;
        }

        const internalAccount = await getInternalAccount(internalAccountId);

        WSQueryCache.setQueryData(
          [QUERY_INTERNAL_ACCOUNT, internalAccountId],
          internalAccount
        );

        return internalAccount;
      });

      const allAccounts = await concurrentActions(actions, {
        concurrentLimit: 5
      });

      return allAccounts;
    },
    config
  );
